/*
 * @Author: panweikang
 * @Date: 2024-01-03 13:31:10
 * @LastEditTime: 2024-01-17 13:22:16
 * @Description:
 */
import React, { useEffect, useState } from 'react'
import './share.scss'
import guideBGPng from '../../../src/static/share/guideBg.png'
import { Image } from 'antd-mobile'
import { useNavigate } from 'react-router-dom'

const MShare = () => {
  let navigate = useNavigate()
  let goBack = () => {
    navigate(-1)
  }
  let goMyReport = () => {
    navigate(`/rlb/YearEndReport/invitation`)
  }

  return (
    <div className="MShare">
      <Image
        fit="contain"
        src={guideBGPng}
        placeholder={<div className="imgLoading">图片加载中...</div>}
      />
      <div className="btnWrap">
        <div className="backBtn" onClick={goBack}></div>
        <div className="myReportBtn" onClick={goMyReport}></div>
      </div>

      {/* <img src={guideBGPng} className="guideBG" alt="guideBGPng" /> */}
      {/* <img src={guideBtnPng} className="guideBtn" alt="guideBtnPng" /> */}
    </div>
  )
}

export default MShare
